import React from 'react';
import { Container, Typography, Paper, Box, Button } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const CODE_HINT: Record<string, string> = {
  db: 'Serwer nie może połączyć się z bazą danych. Sprawdź konfigurację (DB_*) na backendzie.',
  no_user: 'Logowanie Google zakończyło się bez utworzenia sesji. Sprawdź logi serwera (Passport / users).',
  token: 'Nie udało się wygenerować sesji (JWT). Sprawdź JWT_SECRET na serwerze.',
  oauth:
    'Google odrzuciło wymianę kodu na token (OAuth). Na serwerze sprawdź GOOGLE_CLIENT_ID / GOOGLE_WEB_CLIENT_ID, GOOGLE_CLIENT_SECRET i GOOGLE_CALLBACK_URL — muszą być z tego samego projektu co w Google Cloud Console.',
  user_db:
    'Błąd zapisu użytkownika w bazie (np. duplikat e-mail lub ograniczenie SQL). Zobacz log backendu przy linii Sequelize.',
  server: 'Wystąpił błąd po stronie serwera podczas przetwarzania odpowiedzi Google. Zobacz logi backendu (szukaj [auth/googleCallback]).',
};

/**
 * Strona błędu uwierzytelniania
 */
const AuthErrorPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const code = React.useMemo(() => new URLSearchParams(location.search).get('code') || '', [location.search]);
  const detail = code && CODE_HINT[code] ? CODE_HINT[code] : null;

  // Obsługa przycisku powrotu do strony logowania
  const handleBackToLogin = () => {
    navigate('/login');
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8, mb: 4 }}>
        <Paper elevation={3} sx={{ p: 4, borderRadius: 2, textAlign: 'center' }}>
          <Box sx={{ mb: 3, color: 'error.main' }}>
            <ErrorOutlineIcon sx={{ fontSize: 60 }} />
          </Box>
          
          <Typography variant="h5" component="h1" gutterBottom>
            Wystąpił błąd podczas logowania
          </Typography>
          
          <Typography variant="body1" color="text.secondary" sx={{ mb: detail ? 2 : 4 }}>
            Nie udało się zalogować przez Google. Spróbuj ponownie później lub skontaktuj się z administratorem systemu.
          </Typography>
          {detail && (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ mb: 4, textAlign: 'left', bgcolor: 'grey.50', p: 2, borderRadius: 1 }}
            >
              {detail}
            </Typography>
          )}
          
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleBackToLogin}
            size="large"
          >
            Powrót do strony logowania
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default AuthErrorPage;
